import { billsIncluded, features } from '../constants/houseFeatureIds';

export const mapBillsIncluded = bills => {
  if (!(bills instanceof Object)) {
    return undefined;
  }
  return Object.keys(bills)
    .filter(b => !!bills[b])
    .map(id => billsIncluded[id])
    .join(', ');
};

export const mapHouseRules = houseRules => {
  if (!(houseRules instanceof Object)) {
    return undefined;
  }
  return Object.keys(houseRules)
    .map(r => {
      if (r !== 'gender') {
        return houseRules[r] ? r : `not ${r}`;
      }
      return houseRules[r];
    })
    .join(', ');
};

export const mapHouseFeatures = houseFeatures => {
  if (!(houseFeatures instanceof Object)) {
    return undefined;
  }
  return Object.keys(houseFeatures)
    .filter(f => !!houseFeatures[f])
    .map(id => features[id])
    .filter(Boolean)
    .join(', ');
};

export const mapHomecardTypeToProductCategory = type => {
  switch (type) {
    case 'room_shared':
      return 'room_shared_apt';
    case 'apartment':
      return 'whole';
    case 'studio':
      return 'studio';
    case 'residence':
      return 'room_residence';
    default:
      return type;
  }
};

export const mapSliderElements = tracks => tracks.map(e => e.type).join(', ');
